import { useEffect, useState } from 'react'
import GetUrls from 'ts/enums/Url'
import { ProductSubCategory, ProductCategory, Option } from 'ts/types'
import useModalStore from 'store/modal'
import useModalForm from 'hooks/useModalForm'
import { Input, CheckBoxToggle, Select } from 'components/ui'
import useFetch from 'hooks/useFetch'

const ProductSubCategoryAddPage = () => {
const Url = GetUrls();

  const params = useModalStore((state) => state.params) as ProductSubCategory
  const { ModalForm, form } = useModalForm()
  const { setValue, register } = form
  const [isActive, setIsActive] = useState<boolean>(true);
  const [ options, setOptions] = useState<Option[]>([])
  const { data } = useFetch<ProductCategory>(Url.getCategory, Url.getCategory)

  useEffect(() => {
    if (params) {
      setValue('subCategoryId', params.subcategoryId)
      setIsActive(params.isActive);
    }

    const optionList = (data as any).categoryList;
    if(optionList) {
      setOptions(
        optionList.map((dataMap:any) => ({
          value: dataMap.categoryId.toString(),
          children: dataMap.categoryName
        }))
        )
    }
  }, [data, params, setValue])


  const handleToggleActive = (isChecked: boolean) => {
    setIsActive(isChecked);
  }
  
  return (
    <ModalForm
    config={{ url: params ? Url.updateSubcategory : Url.postSubcategory, method: params ? 'PUT' : 'POST' }}
      title={`${params ? 'Edit ' : 'Create ' }Sub Category`}
      description='Create or edit a Sub Category'
    >
      <CheckBoxToggle 
          label="Active" 
          defaultChecked={isActive} 
          onToggle={handleToggleActive}
        />
        <Input
            label="Active" 
            className='hidden'
            {...register("isActive", { value : isActive ? 1 : 0 })}
        />
       {params ? (
        <Input defaultValue={params.subcategoryId} label="ID" disabled />
      ) : null}
      <Input
        defaultValue={params?.subcategoryName}
        label="Sub Category Name"
        {...register('subCategoryName', { required: true })}
      />
      {options.length > 0 ?
        <Select
            defaultValue={params?.categoryId || ''}
            label="Class"
            options={options}
            placeholder='Select a Class...'
            {...register('categoryId', { valueAsNumber: true })}
        />
       :
       <Select
          disabled
          className='opacity-70'
          label="Class"
          defaultValue={"placeholder"}
          options={[{ value:"loading", children:"Loading..." }]}
        />
      }
    </ModalForm>
  )
}

export default ProductSubCategoryAddPage
